import { createContext, FC, ReactNode, useContext } from 'react';

import { VestingGraphData } from '../../../../../hooks/vesting-task/use-vesting-graph';
import { VestingGraphView } from './use-vesting-graph-view';

type VestingGraphViewContextValue = {
  vestingGraph: VestingGraphData;
  view: VestingGraphView;
};

const VestingGraphViewContext = createContext<null | VestingGraphViewContextValue>(null);

export const VestingGraphViewProvider: FC<{
  children: ReactNode;
  value: VestingGraphViewContextValue;
}> = ({ children, value }) => (
  <VestingGraphViewContext.Provider value={value}>{children}</VestingGraphViewContext.Provider>
);

export const useVestingGraphContext = () => {
  const value = useContext(VestingGraphViewContext);
  if (!value) {
    throw new Error('useVestingGraphContext must be used within VestingGraphViewProvider');
  }

  return value;
};
